module.exports = __webpack_public_path__ + "img/LimitBee-4.76ce35eb.png";